export default "__VITE_ASSET__DuntzbFZ__"